import Vue from "vue";
import hasProviderAccessRights from "@/mixins/hasProviderAccessRights";

Vue.mixin(hasProviderAccessRights);
